import { WorkspaceContext } from '@/shared/contexts/workspaceContext'
import { useContext } from 'react'

export const useWorkspaceContext = () => {
  const context = useContext(WorkspaceContext)

  if (!context) {
    throw new Error(
      'useWorkspaceContext must be used within a WorkspaceProvider'
    )
  }

  return context
}
